module.exports = __webpack_public_path__ + "static/media/fog-low.497c8c8a.png";